export default "__VITE_ASSET__DCaY25BD__"